import { QrRegistrationAction } from './actionType'

// No state actually lives here — see actionType.ts's header comment. This
// reducer exists only so QrRegistrationAction joins the store-wide dispatch
// action union via combineReducers (same trick store/apikey's reducer plays
// for its own actions); every case is a no-op.
export type QrRegistrationState = Record<string, never>

const initialState: QrRegistrationState = {}

export function qrRegistrationReducer(state = initialState, action: QrRegistrationAction) {
  switch (action.type) {
    default:
      return state
  }
}
